// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"mobileApplicationSubscriber_wrapper__mf57d","button":"mobileApplicationSubscriber_button__Sv8DB"};